// extracted by mini-css-extract-plugin
module.exports = {"customerSupportLanding":"CustomerSupport_view_customerSupportLanding__RPBUs"};